import React, { useState, useEffect } from 'react'
import { BrowserRouter as Router, Redirect, Route, Switch } from 'react-router-dom'
import * as firebase from 'firebase/app'
import 'firebase/auth'

import App from '../views/app'
import PrivateRoute from './privateRoute'
import Login from '../views/login'

const AppRouter = () => {
	const [isLoading, setIsLoading] = useState(true)

	useEffect(
		() => {
			firebase.auth().onAuthStateChanged(user => {
				setIsLoading(false)
			})
		},
		[]
	)

	if (isLoading) {
		return null
	}

	return (
		<Router>
			<Switch>
				<Route path="/login" component={Login} />
				<PrivateRoute path="/" component={App} />
				<Redirect from='*' to='/notfound' />
			</Switch>
		</Router>
	)
}

export default AppRouter
